/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { Body, Container, Title, SubTitle } from "./styles";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { usePushNotificationsContext } from "contexts/PushNotificationsProvider";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { pwaAssets } from "assets/cdn";
import { useImagePath } from "hooks/useImagePath";

interface PWAPushInfoPopupProps {}

export const PushInfoPopup: React.FC<PWAPushInfoPopupProps> = () => {
	const { getImage } = useImagePath("cdn");
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const backgroundImage = getImage(
		isPortrait
			? pwaAssets.pushInfoBackground
			: pwaAssets.pushInfoBackgroundLandscape
	);

	const { close } = usePopUpsV2();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const scale = useCalculateScale(
		isPortrait ? 363 + 40 : 956 + 40,
		isPortrait ? 613 + 40 : 410 + 40
	);

	useEffect(() => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "pwa_loop_popup_shown",
			event_type: "pwa_loop_popup",
			action: "shown",
			source: "pwa_push",
			page_location: window.location.pathname
		});
		// Only fire once on mount
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onClose = () => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "pwa_loop_popup_closed",
			event_type: "pwa_loop_popup",
			action: "closed",
			source: "pwa_push",
			page_location: window.location.pathname
		});
		//dispatch(onClosePopUp());
		close({ variant: "push-info-popup" });
	};

	return (
		<Container scale={scale} $backgroundImage={backgroundImage}>
			<CloseIconButton onClose={onClose} />
			<Body>
				<Title>
					<div>Stay in the Loop!</div>
				</Title>

				<SubTitle>
					To get notified about new rewards, sales, and exciting updates!
					Please, allow the notifications in your device settings.
				</SubTitle>
			</Body>
		</Container>
	);
};
